import { Component, Output, EventEmitter, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { FileuploaddialogComponent } from '../fileuploaddialog/fileuploaddialog.component';
import { FileuploadService } from '../../service/http/fileupload.service';

@Component({
    selector: 'app-fileupload',
    templateUrl: './fileupload.component.html',
    styleUrls: ['./fileupload.component.css']
})
export class FileuploadComponent {

    constructor(
        public dialog: MatDialog,
        public uploadService: FileuploadService) {}

    @Input()
    acceptFileFormat;

    @Output()
    dialogClosed = new EventEmitter<string>();

    public openUploadDialog() {
        let dialogRef = this.dialog.open(FileuploaddialogComponent, {
            width: '50%',
            height: '50%',
            data: { acceptFileFormat: this.acceptFileFormat }
        });

        dialogRef.afterClosed().subscribe(result => {
          this.dialogClosed.emit("closed");
          console.log(`Dialog result: CLOSED `);
        });
    }
}
